// @flow
import * as React from 'react';

import Container from './Container';
import TextStrong from './TextStrong';

type TProps = {
  onClick: () => void,
  children: string | React.Node,
  primary?: boolean,
  secondary?: boolean,
  color?: string,
};

export default function ButtonBlock(props: TProps): React.Node {
  return (
    <Container
      flex
      fullwidth
      centered
      bordered={props.secondary}
      height={props.secondary ? '52px' : '56px'}
      radius={2}
      hoverColor={props.secondary ? '#0977d1' : undefined}
      hoverFill={props.primary ? '#0977d1' : undefined}
      fill={props.primary ? '#000' : 'transparent'}
      onClick={props.onClick}>
      {props.primary && <h3><TextStrong color="white">{props.children}</TextStrong></h3>}
      {!props.primary && <h4><TextStrong>{props.children}</TextStrong></h4>}
    </Container>
  );
}
